import React from 'react';

import useTranslation from '@hooks/useTranslation';

import type { IHardwareOverviewEquipmentInfo } from '../../model/hardwareOverviewItem';
import Ratio from '../Ratio/Ratio';
import style from './style.module.scss';

interface IProps {
  tooltipId: string;
  info: IHardwareOverviewEquipmentInfo;
}

const TableHardwareEquipmentCell: React.FC<IProps> = ({ tooltipId, info }) => {
  const { t } = useTranslation();

  if (!info) {
    return null;
  }

  return (
    <div
      className={style.facilityEquipItem}
      data-tooltip-id={tooltipId}
      data-qa={`equipmentCounts-${info?.countAiItems || '0'}-${info?.countItems || '0'}`}
      data-tooltip-content={JSON.stringify(info)}
    >
      <span className={style.cellInfo}>{`${info?.countAiItems || '-'}/${info?.countItems || '-'}`}</span>
      <Ratio info={info} />
    </div>
  );
};

export default TableHardwareEquipmentCell;
